export default __webpack_public_path__ + "static/media/popup_close.d761c66a.svg";